import { Breadcrumbs, Content, Loading } from '@orobix/orobix-fe-components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import PageHeader from '../../components/PageHeader/PageHeader'
import { useDispatch, useStore } from '../../store/store'
import {
  emptyProductClasses,
  fetchProduct,
  fetchProductClasses,
  fetchProject,
  fetchTraining,
} from '../../store/storeActions'
import { locations } from '../../utils/locations'
import TrainingTestNewForm from './TrainingTestNewForm'
import useStyles from './TrainingTestNewRoot.styles'

interface RouteParams {
  projectId: string
  productId: string
  trainingId: string
}

const TrainingTestNewRoot = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { product, project, training } = useStore()
  const dispatch = useDispatch()
  const { productId, projectId, trainingId } = useParams<RouteParams>()

  useEffect(() => {
    if (!project) {
      fetchProject(dispatch, Number(projectId))
    }
    if (!product) {
      fetchProduct(dispatch, Number(productId))
    }
    if (!training) {
      fetchTraining(dispatch, Number(trainingId))
    }
  }, [dispatch, product, productId, project, projectId, training, trainingId])

  useEffect(() => {
    fetchProductClasses(dispatch, Number(productId), 1000, 0)

    return () => {
      emptyProductClasses(dispatch)
    }
  }, [dispatch, productId])

  return product && project && training ? (
    <Content
      childrenClassName={classes.content}
      breadcrumbs={
        <Breadcrumbs
          elements={[
            <Link to={locations.projects}>{t('Projects')}</Link>,
            <Link to={locations.products(Number(projectId))}>
              {project.name}
            </Link>,
            <Link
              to={locations.trainings(Number(projectId), Number(productId))}
            >
              {product.name}
            </Link>,
            <Link
              to={locations.trainings(
                Number(projectId),
                Number(productId),
                Number(trainingId)
              )}
            >
              {training.name}
            </Link>,
            t('New test'),
          ]}
        />
      }
    >
      <PageHeader title={t('New test')} />

      <TrainingTestNewForm
        projectId={projectId}
        productId={productId}
        trainingId={trainingId}
        productType={product.type}
      />
    </Content>
  ) : (
    <Content>
      <Loading />
    </Content>
  )
}

export default TrainingTestNewRoot
